<template>
  <div class="page main-background">
    <div class="sub-header">
      <h2>مشخصات کامل خودرو</h2>
    </div>
    <div class="text-color" style="position: relative">
      <div v-if="!loader" class="car-info">
        <div class="tabs">
          <!-- <div class="tab-header card">
            <div class="active col-4 cursor-pointer" ref="brandsHeader" @click="() => {goToTab('brands');}">
              کارخانه سازنده
            </div>
            <div class="col-4 cursor-pointer" ref="countriesHeader" @click="() => { goToTab('countries');}">
              کشور سازنده
            </div>
            <div class="col-4 cursor-pointer">
              نوع ماشین
            </div>
          </div> -->
          <div class="tab-body" id="brands">
            <div ref="brandsBody">
              <router-link tag="div" class="brand-item card" :to="{ path: 'brand/' + brand.id }" v-for="brand in brands"
                :key="brand.Id">
                <img class="logo" :src="brand.logoUrl" />
                <img class="pic" :src="brand.imageUrl" />
                <div>
                  <h3>{{ brand.name }}</h3>
                  <div>
                    <h4>کشور سازنده : {{ brand.countryName }}</h4>
                    <b>سال تاسیس : {{ brand.establishmentYear }}</b>
                  </div>
                </div>
              </router-link>
            </div>
            <div ref="countriesBody"></div>
          </div>
          <!-- <div class="tab-body" id="countries">
            <div ref="brandsBody">
              <div tag="div" class="brand-item card" v-for="brand in brands" :key="brand.Id">
                <img class="pic" :src="brand.ImageUrl" style="margin: 0 auto;">
                <div>
                  <h4 class="textCenter">{{brand.CountryName}}</h4>
                </div>
              </div>
            </div>
            <div ref="countriesBody"></div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import { mapActions } from "vuex";
import api from '../../service'

export default {
  name: 'car-info-home',
  props: {},
  components: {},
  data() {
    return {
      loading: false,
      brands: [],
    }
  },
  mounted: function () {
    this.loading = true
    api.getBrandList().then((response) => {
      // console.log(response);
      if (response.data && response.status === 200) {
        this.brands = response.data.data
        console.log(this.brands)
      }
    })
    if (this.$route.query.theme == 'dark') {
      this.setTheme('dark')
    }
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token)
    }
  },
  // methods: {
  //   ...mapActions(["setTheme", "setToken"]),
  //   goToTab(cTab) {
  //     var tabs = document.querySelectorAll(".tab-header>div");
  //     tabs.forEach(ele => {
  //       ele.classList.remove('active');
  //     });
  //     var brands = document.getElementById('brands');
  //     var countries = document.getElementById('countries');
  //     if (cTab == 'brands') {
  //       this.$refs.brandsHeader.classList.add('active');
  //       brands.style.display = 'block';
  //       countries.style.display = 'none';
  //     }
  //     if (cTab == 'countries') {
  //       this.$refs.countriesHeader.classList.add('active');
  //       brands.style.display = 'none';
  //       countries.style.display = 'block';
  //     }

  //   },
  // },
  // computed: {},
}
</script>
<style scoped>
.card {
  box-shadow: rgba(175, 177, 178, 0.46) 0px 0px 4px 1px;
  margin: 10px 10px 0 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.car-info {
  display: flex;
}

.tabs {
  display: flex;
  max-width: 100%;
  flex: 1;
  flex-direction: column;
}

.tabs>.tab-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
}

.tabs>.tab-header>div {
  padding: 0 10px;
  line-height: 40px;
  height: 42px;
  margin: 0 5px;
  text-align: center;
}

.tabs>.tab-header>div.active {
  background-color: #002664;
  color: #fff;
  border-radius: 5px;
}

.brand-item {
  position: relative;
  background: #fff;
}

.brand-item>div {
  background: rgb(243, 243, 243);
  border-radius: 10px;
  padding: 5px 0;
}

.dark .brand-item>div {
  background: #002664;
}

.brand-item>img.logo {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 80px;
  height: 80px;
  z-index: 2;
  padding: 10px;
}

.brand-item>img.pic {
  position: relative;
  width: 170px;
  padding: 10px;
}

.brand-item>div>h3 {
  font-size: 1.2em;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
}

.brand-item>div>div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: right;
  align-items: center;
  padding: 0 10px;
}
</style>

<!--
<template>
    <div class="carsPriceBg">
      <div class="carsPriceBox">
        <img src="../../assets/img/pic_car_info.jpg">
        <h2 class="textCenter">این بخش به زودی فعال میشود!</h2>
      </div>
    </div>
</template>

<style scoped>
  h2{
    margin: 5px 0 15px 0;
    color: #0a48c2;
    font-size: 18px;
  }
  .carsPriceBg{
    background-image: url(../../assets/img/bg_car_info.jpg);
    height: 100%;
    background-position: center;
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .carsPriceBg img{
    width: 100%;
    border-radius: 20px 20px 0 0;
  }
  .carsPriceBox{
    background: #fff;
    border-radius: 20px;
    margin: 0 10px;
    box-shadow: 0 0 10px #00000070;
  }
  .carsPriceBg button{
    margin-top: 20px;
    background-color: #002664;
  }
</style>
-->
